export { default } from '../components/Icon';